import { useContext, useEffect, useState } from "react";
import performRequest from "network/perform-request";
import { leagueAccessibleCustomersRoute } from "network/api-routes";
import UserContext from "context/UserContext";

let gestionCustomersRequest = null;

function fetchGestionCustomers(user) {
  if (!gestionCustomersRequest) {
    gestionCustomersRequest = performRequest("GET", leagueAccessibleCustomersRoute, {}, true, user).finally(() => {
      gestionCustomersRequest = null;
    });
  }

  return gestionCustomersRequest;
}

export function useGestionCustomers() {
  const { user, loggedIn, gestionCustomers, gestionCustomersLoaded, setGestionCustomers } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!loggedIn || !user) {
      if (gestionCustomers.length > 0) {
        setGestionCustomers([]);
      }
      return;
    }

    if (gestionCustomersLoaded) {
      return;
    }

    let cancelled = false;
    setLoading(true);

    fetchGestionCustomers(user)
      .then((response) => {
        if (cancelled) return;
        setGestionCustomers(response.data?.data ?? []);
        setError(null);
      })
      .catch((err) => {
        if (cancelled) return;
        setGestionCustomers([]);
        setError(err);
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [loggedIn, user, gestionCustomersLoaded, gestionCustomers.length, setGestionCustomers]);

  const refresh = () => {
    if (!loggedIn || !user) return Promise.resolve([]);
    setLoading(true);
    gestionCustomersRequest = null;

    return performRequest("GET", leagueAccessibleCustomersRoute, {}, true, user)
      .then((response) => {
        const data = response.data?.data ?? [];
        setGestionCustomers(data);
        setError(null);
        return data;
      })
      .catch((err) => {
        setGestionCustomers([]);
        setError(err);
        return [];
      })
      .finally(() => setLoading(false));
  };

  return {
    gestionCustomers,
    loading,
    error,
    hasGestionAccess: gestionCustomers.length > 0,
    gestionCustomersLoaded,
    refresh,
  };
}
